import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ImovelType, PlanoType, SafraType } from '../../db/Orm';
import CardAntecipacao, { labelEstado } from '../components/CardAntecipacao';
// import 'primereact/resources/themes/lara-light-indigo/theme.css'; // Escolha o seu tema preferido
import 'primereact/resources/primereact.min.css';                 // Estilos principais do PrimeReact
import 'primeicons/primeicons.css';
import '../../styles/pages/Antecipacoes.css'
import CadastroAntecipacao from './CadastroAntecipacao';

type Props = {
  show: boolean;
  hide: Function;
  planos: PlanoType[]
  propriedades: ImovelType[];
  safras: SafraType[]
  carregarPlanos: ()=>Promise<void>|(()=>void);
}

export const DialogAntecipacoes = (props: Props) => {
  const toast = useRef<Toast | null>(null);
  const [showDialogAntecipacao, setShowDialogAntecipacao] = useState(false);
  const [antecipacao, setAntecipacao] = useState<PlanoType|null>(null)
  
  const status = (plano: PlanoType) => {
    return <>
      {labelEstado(plano)}
    </>
  }
  const [showCadastro, setShowCadastro] = useState(false)
  const handleSuccess = () => {
    if (toast.current) {
      toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Antecipação criada com sucesso!', life: 3000 });
    }
    props.carregarPlanos();
  };
  useEffect(() => {
    if (showDialogAntecipacao) return
    setAntecipacao(null)
  }, [showDialogAntecipacao])
  useEffect(()=>{
    if (!antecipacao) return
    const antecipacaoUpdate = props.planos.find(v=>v.id===antecipacao.id)
    if (!antecipacaoUpdate){
      console.error('A antecipação escolhida não foi encontrada entre os planos')
      setShowDialogAntecipacao(false)
      return
    }
    setAntecipacao(antecipacaoUpdate)
  }, [props.planos])

  return (
    <Dialog header="Antecipações [AREA EM DESENVOLVIMENTO]" visible={props.show} className='antecipacoes-dialog' onHide={() => { props.hide(); }} draggable={false} resizable={false}>
      <Toast ref={toast} position="center"></Toast>
      {/* <CardAntecipacao antecipacao={antecipacao} propriedades={props.propriedades} /> */}
      <Dialog header="Antecipação" visible={showDialogAntecipacao} className='antecipacao-dialog' onHide={() => setShowDialogAntecipacao(false)} draggable={false} resizable={false}>
        <CardAntecipacao antecipacao={antecipacao} propriedades={props.propriedades} carregarPlanos={props.carregarPlanos} />
      </Dialog>
      <CadastroAntecipacao show={showCadastro} setShow={setShowCadastro} propriedades={props.propriedades} safras={props.safras} onSuccess={handleSuccess} />
      <div className='antecipacoes-top' >
        <Button icon="pi pi-refresh" className="p-button-rounded p-button-text" onClick={() => props.carregarPlanos()} />
        <Button label="Nova Antecipação" icon="pi pi-plus" onClick={() => setShowCadastro(true)} />
      </div>
      <DataTable value={props.planos} selectionMode="single" selection={antecipacao} onRowSelect={(row) => setAntecipacao(row.data)} dataKey="id" scrollable>
        <Column body={(plano) => <>{plano.propriedade?.nome}</>} header="Imóvel"></Column>
        <Column body={(plano) => <>{plano.safra?.periodo}</>} header="Safra"></Column>
        <Column body={status} header="Status"></Column>
        <Column body={(antecipacao) => <Button label="Abrir" className="p-button-sm antecipacoes-table-button" onClick={() => { setAntecipacao(antecipacao); setShowDialogAntecipacao(true) }} />} />
      </DataTable>
    </Dialog>
  );
}
